module.exports = __webpack_public_path__ + "static/media/mainbiz.be4c55d4.png";